import { createChatOutbox } from '~/utils/chat-outbox'

export default function ({ app, store }, inject) {
  const outbox = createChatOutbox({
    getAccountId: () => app.$auth.user?.id ?? null,
    post: payload => app.$axios.post('/api/messages', payload, { timeout: 30000 }),
    sent: message => {
      store.dispatch('chat/moveUserToTop', message.user_id)
      app.$echo.private('user.' + message.author_id).whisper('sended_message_to_user', { message })
    },
    report: error => {
      // Never forward Axios config containing message text or auth headers.
      app.$sentry.captureException(new Error(error.contract ? error.message : 'Chat message send failed'), {
        extra: error.contract || { http_status: error.response?.status, code: error.code }
      })
    }
  })
  inject('chatOutbox', outbox)
  if (process.server) return
  store.watch(() => app.$auth.user?.id, () => outbox.reset(), { sync: true })
  window.addEventListener('beforeunload', event => {
    if (!outbox.hasUnsent()) return
    event.preventDefault()
    event.returnValue = ''
  })
}
